import { useState } from "react";
import { FileTextOutlined } from "@ant-design/icons";
import "./DokumentListKorisnik.css";
import StatistikaDokumentaService from "../../services/statistikaDokumenta.service";
import { formatDateTime } from "../../utils/formatDateTime";
import dayjs from "dayjs";

function DokumentsListKorisnik({ dokumenti }) {
  const handleOpenPdf = async (dokument) => {
    if (!dokument.putanja) return;

    const filename = dokument.putanja.split("/").pop();
    const url = `/dokument/preview/${filename}`;

    const isPdf = filename.toLowerCase().endsWith(".pdf");

    if (isPdf) {
      window.open(url, "_blank");
    } else {
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error("Network response was not ok");

        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(downloadUrl);
        }, 100);
      } catch (error) {}
    }
  };
  const handleClickDokument = async (dokumentId) => {
    const novaStatistika = {
      vremenskaOznaka: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
      dokumentId: dokumentId,
    };

    try {
      await StatistikaDokumentaService.addStatistikaDokumenta(novaStatistika);
    } catch (error) {}
  };

  const colors = ["#c9bc8d", "#f7eba8", "#babd7d", "#ded6a0"];
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentDokumenti = dokumenti.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(dokumenti.length / itemsPerPage);
  return (
    <div className="documents-list-container-korisnik">
      {currentDokumenti.length === 0 ? (
        <p style={{ textAlign: "center", color: "#c8c3a7" }}>
          Nema dostupnih dokumenata.
        </p>
      ) : (
        currentDokumenti.map((dokument, index) => {
          const backgroundColor = colors[index % colors.length];

          return (
            <div
              key={dokument.id}
              className="dokument-kartica"
              style={{ backgroundColor }}
              onClick={() => {
                handleClickDokument(dokument.id);
                handleOpenPdf(dokument);
              }}
            >
              <div className="kartica-sadrzaj">
                <div className="kartica-ikona">
                  <FileTextOutlined />
                </div>

                <div className="kartica-tekst">
                  <div className="kartica-zaglavlje">
                    <h3 className="kartica-naslov">{dokument.naziv}</h3>
                    <p className="kartica-datum">
                      <span>({dokument.putanja.split(".").pop()}) </span>
                      {formatDateTime(dokument.datumDodavanja)}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      )}

      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            {" "}
            Prethodna{" "}
          </button>
          <span>
            Stranica {currentPage} od {totalPages}
          </span>
          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            {" "}
            Sljedeća
          </button>
        </div>
      )}
    </div>
  );
}

export default DokumentsListKorisnik;
